export default __webpack_public_path__ + "static/media/services.47c07439.webp";